import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';
import { styled as materialStyled } from '@mui/material/styles';
import { theme } from '../../../theme/theme';

interface ICustomButtonProps {
  padding?: string;
  radius?: string;
  height?: string;
  fontSize?: number;
}

const CustomButton = materialStyled(LoadingButton)<ICustomButtonProps>(
  ({ padding = '12px', radius = '8px', height = '38px', fontSize = 15, variant }) => ({
    borderRadius: radius,
    padding,
    textAlign: 'center',
    textTransform: 'none',
    fontFamily: 'Inter',
    fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'normal',
    height,
    boxShadow: ' 0px 12px 12px 0px rgba(255, 255, 255, 0.12) inset, 0px -2px 2px 0px rgba(48, 48, 48, 0.10) inset',
    backgroundColor: variant === 'outlined' ? `${theme.palette.white.main}` : `${theme.palette.shades.lightBlueColor}`,
    border: variant === 'outlined' ? `1px solid ${theme.palette.shades.lightBlueColor}` : 'none',
    '&:disabled': {
      backgroundColor: theme.palette.info.light,
      color: theme.palette.common.black,
    },
    color: variant === 'outlined' ? theme.palette.shades.buttonOutline : 'none',
  }),
);

export default CustomButton;
